import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import Avatar from '../Avatar/Avatar';
import { WithTooltip } from '../Elements';

import { getInitialsFull } from 'utils/common';

import classes from './TablePerson.module.scss';

const TablePerson = ({ person, initialsColor, size = 's' }) => (
  <WithTooltip text={person}>
    <div>
      <Avatar
        className={cn(
          classes.avatar,
          size === 's' ? classes.avatar_small : classes.avatar_large
        )}
        initials={getInitialsFull(person)}
        initialsColor={initialsColor}
      />
    </div>
  </WithTooltip>
);

TablePerson.propTypes = {
  person: PropTypes.string.isRequired,
  initialsColor: PropTypes.string,
  size: PropTypes.oneOf(['s', 'l'])
};

export default TablePerson;
